export class BaseSaveProcessNotesParametersDto {
    id: string;
    note: string;
}
